import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { ReportsListResponse } from 'src/types/reports';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class ReportsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getReportsList(
    type: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.reports.reportsList,
      params: { type },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPaginatedReportsList(params: {
    type: string;
    search: string;
    sort: string;
    page: number;
    pageSize: number;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      ReportsListResponse | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.reports.reportsList,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getUnifiedBenefitsReportsList(params: {
    search: string;
    sort: string;
    page: number;
    pageSize: number;
  }): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      ReportsListResponse | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.reports.unifiedBenefitsList,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
